export default __webpack_public_path__ + "static/media/W.ff5118d5.svg";